import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const TransactionsSummaryStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightBold,
      fontSize: "20px",
      selfAlign: "end",
    },
    transactionButtonContainer: {
      width: "100%",
      height: "48px",
      marginBottom: "30px",
    },
    transactionButton: {
      width: "100%",
      height: "48px",
    },
    transactionButtonText: {
      fontSize: "16px",
      fontWeight: 600,
    },
    button: {
      color: "#FFFFFF",
      backgroundColor: theme.palette.secondary.main,
      textTransform: "none",
      marginTop: "12px",
      width: "100%",
      height: "48px",
      transition: "background 0.5s, color 0.5s",
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
      },
    },
    transactionDate: {
      fontSize: "16px",
      color: "#7B858B",
      fontWeight: 600,
    },
    exportText: {
      color: "#FFFFFF",
      fontSize: "16px",
      lineHeight: "19px",
      textAlign: "left",
    },
    message: {
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: "18px",
      margin: "12px 6px 12px 0px",
    },
    noDataMessage: {
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: "18px",
      margin: "12px 6px 12px 0px",
      color: theme.palette.secondary.main,
    },
    fab: {
      margin: 0,
      right: "52%",
      bottom: 42,
      left: "auto",
      position: "fixed",
      width: "42px",
      height: "38px",
    },
  }),
);
